import { FormattedMessage } from 'react-intl';

import Divider from '../common/Divider';

import styles from './PlansScreenFooter.module.scss';

import { getCurrentYear } from '@/utils/getCurrentYear';

const bottomDividerPadding = 16;

const PlansSceenFooter = () => (
  <footer className={styles.footer}>
    {/* <p className={styles.disclaimer}>
      <FormattedMessage
        id="plansScreen.footer.disclaimer"
        defaultMessage="By clicking “Continue” and purchasing, you agree to our Terms of Service and Privacy Policy.
        To ensure uninterrupted access after your subscription ends, you agree that your subscription will renew for
        another term using the payment method provided. You may turn off auto-renewal at any time by logging into your
        account. Some products are provided by third parties and your access to them is also subject to their terms."
        description="Plans screen footer disclaimer"
      />
    </p> */}

    <Divider size="wide" spacing={[0, bottomDividerPadding]} />

    <div className={styles.bottomLine}>
      <div className={styles.links}>
        <a href="https://clearvpn.com/privacy-policy/">
          <FormattedMessage
            id="plansScreen.footer.privacyPolicyLink"
            defaultMessage="Privacy policy"
            description="Link to privacy policy page"
          />
        </a>
        <a href="https://clearvpn.com/terms-of-service/">
          <FormattedMessage
            id="plansScreen.footer.termsOfServiceLink"
            defaultMessage="Terms & Conditions"
            description="Link to terms of service page"
          />
        </a>
        <a href="https://support.clearvpn.com/hc/requests/new">
          <FormattedMessage
            id="plansScreen.footer.supportLink"
            defaultMessage="Support"
            description="Link to support page"
          />
        </a>
      </div>

      <span className={styles.copyright}>© {getCurrentYear()} ClearVPN</span>
    </div>
  </footer>
);

export default PlansSceenFooter;
